<template>
    <rkm-table
        :items="items"
        :fields="fields.table"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="edit(item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins
import { repository, error } from '@/mixins'

//Vuex
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            return {

                table: [
                    { label: 'Medicamento', key: 'descricao', sortable: true },
                    { label: 'Ações', key: 'actions', class: 'col-min' },
                ]
            }
        },
    },
    created() {

        this.repositories = {
            medicamentoNaoPadronizado: this.getConectaSusRepository('cadastro.medicamentoNaoPadronizado'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        edit(item) {

            this.$emit('edit', item)
        },
        destroy(item) {

            const destroy = async () => {

                const idx = this.items.findIndex(i => i.id === item.id)

                if (Number.isInteger(this.items[idx].id)) {

                    this.setLoading()

                    this.repositories.medicamentoNaoPadronizado.destroy(this.items[idx].id)
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

                    return
                }

                this.items.splice(idx, 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir o medicamento!', destroy)
        },
    },
    mixins: [repository, error],
    props: {
        items: { type: Array, default: () => [] },
    }
}
</script>